import React from 'react';
import { useSelector } from 'react-redux';

import EmptyListing from 'src/components/EmptyListing/EmptyListing';

import 'src/components/EmptyListing/ChosenEmptyListing.scss';

import Magnify from '@mdi/svg/svg/magnify.svg';
import ArrowRight from '@mdi/svg/svg/arrow-right.svg';


const ChosenEmptyListing = () => {
  const searchFilterURL = useSelector(({ configReducer }) => configReducer.searchFilterURL);

  const titleText = 'Zacznij szukać, przygotujemy dla Ciebie najlepsze oferty';

  return (
    <EmptyListing
      copy={ (
        <p styleName="copy">
          { titleText }
          <ArrowRight styleName="copy__arrow" viewBox="0 0 24 24" />
        </p>
      ) }
      dataTest="anchor-search"
      header="Poznajmy się lepiej"
      icon={ Magnify }
      link={ searchFilterURL }
    />
  );
};


export default ChosenEmptyListing;
